<template>
  <div>
    <SettingsModal style="display: none" class="modal" ref="settingsModal" />
    <SectionsModal style="display: none" class="modal" ref="sectionsModal" />
    <PowersModal style="display: none" class="modal" ref="powersModal" />
    <StudioWelcomeModal style="display: none" class="modal" />
    <!-- <EventInformation v-if="canSee" /> -->
    <template v-if="isStudioEvent">
      <StudioEventModal
        style="display: none"
        class="modal"
        ref="studioEventModal"
      />
      <ExitDialogModal style="display: none" class="modal" />
      <CompetitionSubmitted style="display: none" class="modal" />
      <StudioEventTimeOverModal
        style="display: none"
        class="modal"
        ref="studioEventTimeOverModal"
      />
      <StudioEventFullyCompletedModal
        style="display: none"
        class="modal"
        ref="studioEventFullyCompletedModal"
      />
    </template>
    <template v-else>
      <CouponModal style="display: none" class="modal" />
      <EndOfPackage style="display: none" class="modal" />
      <StudioEventRedirectModal style="display: none" class="modal" />
    </template>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent as d } from 'vue';

import PageUtils from '@/utils/page-utils';

const SettingsModal = d(() => import('@/components/modals/SettingsModal.vue'));
const SectionsModal = d(() => import('@/components/modals/SectionsModal.vue'));
const PowersModal = d(() => import('@/components/modals/PowersModal.vue'));
const CouponModal = d(() => import('@/components/modals/CouponModal.vue'));
const StudioEventModal = d(
  () => import('@/components/modals/StudioEventModal.vue')
);
const StudioWelcomeModal = d(
  () => import('@/components/modals/StudioWelcomeModal.vue')
);
const EndOfPackage = d(() => import('@/components/modals/EndOfPackage.vue'));
const ExitDialogModal = d(
  () => import('@/components/modals/ExitDialogModal.vue')
);
const CompetitionSubmitted = d(
  () => import('@/components/modals/CompetitionSubmitted.vue')
);
const StudioEventRedirectModal = d(
  () => import('@/components/modals/StudioEventRedirectModal.vue')
);
const StudioEventTimeOverModal = d(
  () => import('@/components/modals/StudioEventTimeOverModal.vue')
);
const StudioEventFullyCompletedModal = d(
  () => import('@/components/modals/StudioEventFullyCompletedModal.vue')
);

const isStudioEvent = computed(() => PageUtils.isStudioEvent());
</script>
